import * as React from 'react';
import MediaObject from 'components/MediaObject';
import Text from 'components/Text';
import { GetLanguageSet_translations_getLanguageSet_data_languageCounts as LanguageCounts } from 'translations/queries/__generated__/GetLanguageSet';
import SettingsStore from 'stores/SettingsStore';
import MenuItem from 'components/MenuItem';
import { Intent, EditedMessageTranslationsType } from 'translations/types';

type Props = {
  detectedMessageLanguage: string;
  shouldTranslate: boolean;
  languageCount: LanguageCounts;
  onSelect: (languageCode: String) => void;
  disabled: boolean;
  editedTranslations: EditedMessageTranslationsType;
};

export const TranslationsHoverCardRow = (props: Props) => {
  const languages = SettingsStore.getLanguages();
  const secondaryLanguage = languages?.secondary;

  const {
    languageCount,
    shouldTranslate,
    detectedMessageLanguage,
    onSelect,
    disabled,
    editedTranslations,
  } = props;

  const { languageCode, count } = languageCount;
  const languageString =
    (secondaryLanguage && secondaryLanguage[languageCode]) ?? 'No preference set';
  const subTextColor = shouldTranslate ? 'graphite' : 'graphite';
  const autoTranslateString: Intent = 'Autotranslated';

  return (
    <MenuItem
      data-test={`translations-hover-card-row-${languageCode}`}
      menuKey={languageCode}
      onSelect={onSelect}
      disabled={disabled}
      noHover={disabled}>
      <MediaObject gutter="xsmall" figure="left">
        <Text size="small" color="black" lineHeight="flush">
          {languageString}
        </Text>
        <MediaObject gutter="small">
          <Text weight="normal" size="xxsmall" align="left" color={subTextColor}>
            {count} {count > 1 ? 'recipients' : 'recipient'}
          </Text>
          <Text align="right" size="xxsmall" weight="normal" color={subTextColor}>
            {languageCode === detectedMessageLanguage && detectedMessageLanguage !== 'none'
              ? 'Original'
              : editedTranslations[languageCode]?.intent.replace(autoTranslateString, '')}
          </Text>
        </MediaObject>
      </MediaObject>
    </MenuItem>
  );
};

export default TranslationsHoverCardRow;
